var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "orders-carousel-component" },
    [
      _c(
        "carousel",
        {
          ref: "orders-carousel",
          staticClass: "orders-carousel",
          attrs: {
            "pagination-enabled": true,
            "per-page-custom": [[0, 1], [768, 2], [1145, 3]],
            "min-swipe-distance": 40,
            "pagination-active-color": "#8071F3",
            "navigation-enabled": true,
            "pagination-color": "rgba(128, 113, 243, 0.4)",
            "pagination-size": 8,
            loop: true
          },
          on: { "page-change": _vm.ordersCarouselPageChange }
        },
        [
          _vm._t("default", null, {
            callbackRegTurnkey: _vm.callbackRegTurnkey,
            callbackRegFast: _vm.callbackRegFast,
            callbackRegPaidSocial: _vm.callbackRegPaidSocial,
            callbackRegPaidDocs: _vm.callbackRegPaidDocs,
            callbackReportMoneyTransfer: _vm.callbackReportMoneyTransfer,
            callbackOpenAccountNotify: _vm.callbackOpenAccountNotify,
            callbackTrader: _vm.callbackTrader,
            callbackTraderPlus: _vm.callbackTraderPlus,
            callbackOneDayDeclaration: _vm.callbackOneDayDeclaration,
            callbackSuccessfulSolution: _vm.callbackSuccessfulSolution,
            callbackVipConsultation: _vm.callbackVipConsultation,
            callbackFreeConsultation: _vm.callbackFreeConsultation,
            callbackExpeditedReturn: _vm.callbackExpeditedReturn,
            scrollToRega: _vm.scrollToRega
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("div", {
        directives: [
          { name: "show", rawName: "v-show", value: false, expression: "false" }
        ],
        staticClass: "space-plug"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }